module.exports = __webpack_public_path__ + "ba8d54eb8d86991d3a26a309bba98613.fbx";